import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage } from '../../utility/modals';
import { OrganisationService } from './organisation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrganisationmodalComponent } from '../../directives/organisationmodal/organisationmodal.component';
import { OrganisationbusinessusermodalComponent } from '../../directives/organisationbusinessusermodal/organisationbusinessusermodal.component';
import { OrganisationcrmusermodalComponent } from '../../directives/organisationcrmusermodal/organisationcrmusermodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.css']
})
export class OrganisationComponent {

   tableData: any[] = []; 
    selectedItem: MenuItem | null = null;
    commonScrollHeight='';
    searchText: string;
    ref: DynamicDialogRef | undefined;
    first2: number = 0;
    rows2: number = 10;
    totalRecords: number= 0;
    options = [];
    paginatorArray=[]
    visible:boolean=false;
    excel_paragraph='';
    templatedownloadtext='';
    exceldownloadModal=false;
    downloadformate=false;
    position='top';
    cols=[];
    loginuserid=0
    message:GlobalMessage=new GlobalMessage()
    _selectedColumns=[];
    bdteam=false;
    isCrm=1;
    sortorder=1;
    orgid: number;
    sortfield='orgid';
    isSupportAdmin = "N";
    constructor(public router: Router,public dialogService: DialogService,
      private orgservice:OrganisationService,private utilityservice:Utilityservice,
    private spinner:NgxSpinnerService,public helpservice:PagehelpmodalService){
        this.excel_paragraph=this.message.downloadexcel_text;
      this.templatedownloadtext=this.message.excelformate_text;
      const userdata= this.utilityservice.getLoggeduser();
     this.loginuserid=userdata.userid;
     this.orgid = userdata.orgid; 
     this.isSupportAdmin = userdata.issupportadmin; 
        let userrole=this.utilityservice.getUserRights().roleid.toString()

    //  if useris is 3458 if userrole =1 && if product id =12
    // if(this.loginuserid==3458 && userrole==1){
    // this.bdteam=true
    // }    
     
   this.orgservice.getbdteamsdata(this.loginuserid).subscribe(res=>{    
    if(res[0].verticalid1==="59" && (this.utilityservice.getUserRights().roleid.toString()=='1' || this.loginuserid==0)){
      this.bdteam=true
    }
   }) 
      }
  
    ngOnInit() {
     this.commonScrollHeight=  this.utilityservice.updateScrollHeight()
      // this.getgriddata();
      this.dynamiccols();
    }
    @HostListener('window:resize', ['$event'])
    onResize(event) {
    this.commonScrollHeight=this.utilityservice.updateScrollHeight();
  }
  dynamiccols(){
    //orgtype S Self else Practicing Firm
    this.cols=[
      {field:'orgid',header:'ID',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
      {field:'name',header:'Organisation Name',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
      {field:'orgtype',header:'Org.Type',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'}, 
      { field: "orginitial", header: "Org.Initial",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' },
      { field: "enterprise", header: "Cloud/Enterprise",type:'text',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' }, 
      { field: "createddate", header: "Created On",type:'date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    ]
   this._selectedColumns = this.cols;
  //  this.getgriddata()
   
  }
   
      getgriddatalazy( event:LazyLoadEvent) {
        // this.spinner.show();
        console.log(event,"event load");
      this.first2=event.first;
        this.rows2=event.rows
        // this.orgservice.lazyLoad$.next(event)
         let page = event.first / event.rows + 1;
       let dynamicquery={
          // page:'1',
          // size:10,
          // filters:[],
          // global:[],
        }
            dynamicquery['page']=page
          dynamicquery['size']=event.rows;
          dynamicquery['filters']=event.filters;
          dynamicquery['sortField']=event.sortField
          dynamicquery['sortOrder']=event.sortOrder;
        this.orgservice.getgridlazyload(dynamicquery).subscribe((data) => {
          this.spinner.hide();
          this.tableData = data.orgdata;
              //orgtype S Self else Practicing Firm

            this.tableData.map(e=>{
    // if(e.enterprise=='C'){
    //   e['enterprise']='Cloud'
    // } else{
    //     e['enterprise']='Enterprise'

    // }
     //orgtype S Self else Practicing Firm
    //  if(e.orgtype=='S'){
    //   e['type']='Self'
    //  }else{
    //   e['type']='Practicing Firm'
    //  }
  
  })
          this.totalRecords = data.totalcount;

          this.options=  this.utilityservice.getOptionDropdown(data.totalcount);
          this.paginatorArray=this.options.map(e=>e.value);
        },error=>{
                    this.spinner.hide();

        });
      }

      bdusermodalopen(title,data){
        let details:any
           this.spinner.show()
      this.orgservice.getorgdetailsbyId(data.orgid).subscribe(res=>{
            this.spinner.hide()
        details=res;
        this.ref = this.dialogService.open(OrganisationbusinessusermodalComponent, { header: title,
          height:'auto',
          width:'90vw',
        data:{title:title,datas:details[0],orgid:data.orgid},
        contentStyle: {  },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        // this.getgriddata();
        });
      },error=>{
         this.spinner.hide()

      })

      }
   getgriddata(){
const currentPageSize=this.rows2
      this.orgservice.getgrid().subscribe((data) => {
          this.spinner.hide();
          this.tableData = data.orgdata;
              //orgtype S Self else Practicing Firm

            this.tableData.map(e=>{
    // if(e.enterprise=='C'){
    //   e['enterpricedata']='Cloud'
    // } else{
    //     e['enterpricedata']='Enterprise'

    // }
     //orgtype S Self else Practicing Firm
    //  if(e.orgtype=='S'){
    //   e['type']='Self'
    //  }else{
    //   e['type']='Practicing Firm'
    //  }
  
  })
             this.options = this.utilityservice.getOptionDropdown(this.tableData.length) || [];
      this.paginatorArray = this.options.map((e: any) => +e.value);
  if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }
        this.rows2 = currentPageSize;
        this.totalRecords = this.tableData.length;
        },error=>{
                    this.spinner.hide();

        });
   }
  openmodal(title,data) {    
    let details={}  
    if(title==='Modify Organisation' || title==='View Organisation'){
          this.spinner.show()
      this.orgservice.getorgdetailsbyId(data.orgid).subscribe(res=>{
            this.spinner.hide()
        details=res;
        this.ref = this.dialogService.open(OrganisationmodalComponent, { header: title,
          height:'100%',
          width:'90vw',
        data:{title:title,datas:details[0],orgid:data.orgid,isBdTeam:this.bdteam},
        contentStyle: {  },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        // this.getgriddata();
        });
      },error=>{
         this.spinner.hide()

      })
    }
    else if(title==='Modify License Detail'){
          this.spinner.show() 
      this.orgservice.getorgdetailsbyId(data.orgid).subscribe(res=>{
            this.spinner.hide()
        details=res;
        this.ref = this.dialogService.open(OrganisationcrmusermodalComponent, { header: title,
          height:'100%',
          width:'90vw',
        data:{title:title,datas:details[0],orgid:data.orgid},
        contentStyle: {  },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        // this.getgriddata();
        });
      },error=>{
         this.spinner.hide()

      })
    }
    else if(title==='Product Wise Email Status'){
       details={}
      this.ref = this.dialogService.open(OrganisationmodalComponent, { header: title,
        width:'90vw',
        height:'auto',
        data:{title:title,orgid:data.orgid},
      contentStyle: { overflow: ''  },
      baseZIndex: 10000,
      maximizable: false,
    });
    // this.ref.onClose.subscribe(res=>{
    //   if(res=='Save'){
    //        this.sortorder=-1;
    //       this.sortfield='createddate';
        
    //   }
    // })
    }
    else{
      details={}
      this.ref = this.dialogService.open(OrganisationmodalComponent, { header: title,
        width:'90vw',
        height:'auto',
        data:{title:title,orgid:data.orgid},
      contentStyle: { overflow: ''  },
      baseZIndex: 10000,
      maximizable: true,
    });
    this.ref.onClose.subscribe(res=>{
      if(res=='Save'){
           this.sortorder=-1;
          this.sortfield='createddate';
        
      }
    })
    }
  }
  
 
   
   
    handlePageChange(event: any) {
      this.rows2=event.rows
    }
    customSort(event: SortEvent) {
      event.data.sort((data1, data2) => {
          let value1 = data1[event.field];
          let value2 = data2[event.field];
          let result = 0;
  
          // Handling null values
          if (value1 == null && value2 != null) return -1;
          if (value1 != null && value2 == null) return 1;
          if (value1 == null && value2 == null) return 0;
  
          // Check if the field is createdon for date comparison
          if (event.field === 'createdon') {
              // Parse the date strings to Date objects
              const date1 = new Date(value1);
              const date2 = new Date(value2);
              return date1.getTime() - date2.getTime(); // Sort by timestamp
          }
  
          // Handle string comparisons
          if (typeof value1 === 'string' && typeof value2 === 'string') {
              return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
          }
  
          // Fallback to default number comparison for other types
          return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
      });
      
      return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }
  



  exceDownloadModel() {
    let payload = {
      isBdTeam: this.bdteam

    }
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
       data: {
        excelname: "License change details.xlsx", downloadapi: 'common/organisation/getlicenseexcel',
        method: 'get', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      maximizable: false,

    })
  }
  superadmingridexceDownloadModel() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
       data: {
        excelname: "superadmin_organisation_details.xlsx", downloadapi: 'common/organisation/getsuperadminexcel',
        method: 'get', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      maximizable: false,

    })
  }
    ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
  

}
